<script>
    import { getContext } from 'svelte';
    import { publishOpenAction } from './openable';
    import CopyButton from '../CopyButton.svelte';
    import PlaygroundHelper from '../scripts/playgroundhelper';
    import FormatHelper from '../scripts/FormatHelper';

    export let edit;
    $: playground = edit ? edit.playground : null;
    $: playgroundTitle = PlaygroundHelper.presentPlayground(playground);

    // Lets the sidebar open the item from the keyboard
    $: publishOpenAction(edit, action);

    /**
     * Callback (edit) => () for when an edit has been handled. The updated edit will be passed in.
     *
     * @type Function
     */
    export let editHandled;

    let getMap = getContext('getMap');

    function editClosed() {
        if (!edit || !editHandled) {
            return;
        }

        // Make sure the item was indeed handled
        if (edit.metadata.state == 'open') {
            return;
        }

        // Let the sidebar know that this item should be removed
        editHandled(edit);
    }

    function action() {
        if (edit.state === 'removed') {
            getMap().openApproveRemovalPopup(edit, editClosed);
        } else {
            getMap().openApproveEditPopup(edit, editClosed);
        }
    }

</script>

<p>
    <!-- svelte-ignore a11y-invalid-attribute -->
    {#if edit.state === 'removed'}
        <a class="removal" href="#" on:click|preventDefault={action}>Ta bort: {playgroundTitle}</a>
    {:else}
        <a href="#" on:click|preventDefault={action}>Ändringar: {playgroundTitle}</a>
    {/if}
</p>
<p class="small-line">
    {FormatHelper.dateTime(edit.metadata.created)}
</p>
<p class="small-line">
    <i class="fas fa-edit" />
    {edit._id}<CopyButton text={edit._id} />
</p>
<p class="small-line">
    <i class="fas fa-map-marker" />
    {playground._id}
    <CopyButton text={playground._id} />
</p>
{#if edit.metadata.user}
    <p class="small-line">
        <i class="fas fa-user" />
        {edit.metadata.user}<CopyButton text={edit.metadata.user} />
    </p>
{/if}

<style>
    p {
        margin: 0;
        padding: 0;
    }

    p.small-line {
        font-size: 12px;
    }

    a.removal {
        color: #dc3545;
    }
</style>
